import React, { useState, useEffect } from 'react';
import { useFormikContext } from 'formik';
import moment from 'moment';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import CircularLoading from '../../../../common/components/CircularLoading/CircularLoading';
import initialImg from '../../../../images/icons/upload_new.svg';
import GlobalMonthRangePicker from '../../../../common/components/GlobalMonthPicker/GlobalMonthPicker';
import { ShowGetImage } from '../../../../common/components/ShowGetImage/ShowGetImage';
import RadioButton from '../../../../components/Dashboard-res/CommonComponent/RadioButton';
import Form16MultiParts from './Form16MultiParts';
import PopUp from '../../../../common/components/PopUp/PopUp';

import {
  incomeDocUpload,
  UploadFileToS3,
  incomeDocUploaded,
  getIncomeSalaryDoc
} from '../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import get from 'lodash/get';
import { staticData } from 'gatsby-env-variables';
import { isLems } from '../../../../../../lems-ui/src/common/constants';

const Form16 = () => {
  const [showFullImage, setShowFullImage] = useState(false);
  const [salaryMinUploaded, setSalaryMinUploaded] = useState(false);
  const [F16MinUploaded, setF16MinUploaded] = useState(false);
  const [salaryDocUploads, setSalaryDocUploads] = useState({});
  const [getSalaryDoc, setGetSalaryDoc] = useState([]);
  const [getForm16Doc, setForm16Doc] = useState([]);
  const [docUploaded, setDocUploaded] = useState(false);
  const [docUploadError, setDocUploadError] = useState(false);
  const [show, setShow] = useState(true);
  const [leadAppicant_Id, setLeadApplicant_Id] = useState('');
  const [lead_Id, setLead_id] = useState('');
  const [docId, setDocId] = useState('');
  const [loading, setLoading] = useState(false);
  const [salaryMonths, setSalaryMonths] = useState({});
  const [edit0, setEdit0] = useState(false);
  const [edit1, setEdit1] = useState(false);
  const [edit2, setEdit2] = useState(false);
  const [edit3, setEdit3] = useState(false);
  const [edit4, setEdit4] = useState(false);
  const [letGetOver, setLetGetOver] = useState(false);
  const [form16File, setForm16File] = useState('singleFile');
  const [form16Result, setForm16Result] = useState([]);

  const [validRange, setValidRange] = useState({
    min: { year: 2011, month: 1 },
    max: {
      year: 2020,
      month:
        moment()
          .subtract(1, 'months')
          .month() + 1
    }
  });

  const [rangeValue, setRangeValue] = useState({
    from: { year: 2020, month: 4 },
    to: {
      year: 2020,
      month:
        moment()
          .subtract(1, 'months')
          .month() + 1
    }
  });
  // states for multiple values
  const [multiValue, setMultiValue] = useState([
    { year: 2016, month: 7 },
    { year: 2016, month: 11 },
    { year: 2017, month: 3 },
    { year: 2019, month: 5 }
  ]);
  const tags = [
    'previousYearTypeA',
    'lastPreviousYearTypeA',
    'previousYearTypeB',
    'lastpreviousYearTypeB'
  ];
  const {
    values: data,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();
  const validationSalarySlipFields = [data.file[0], data.file[1], data.file[2]];
  const validationF16SlipFields = [data.file[3], data.file[4]];

  useEffect(() => {
    let leadDetails = getApplicantionInfo();
    const { leadId, leadApplicantId } = leadDetails;
    setLead_id(leadId);
    setLeadApplicant_Id(leadApplicantId);
    return () => {
      data.file = [];
      data.imgUrl = [];
    };
  }, []);

  // getForSalarySlip
  useEffect(() => {
    (async () => {
      if (lead_Id && leadAppicant_Id) {
        await getIncomeSalaryDoc(
          lead_Id,
          leadAppicant_Id,
          'income',
          'salary-slip'
        )
          .then(res => {
            let temp = [];
            if (res.links.length > 0)
              res.links.map(el => {
                if (el.tag === 'firstSalary') temp.splice(0, 0, el.url);
                if (el.tag === 'secondSalary') temp.splice(1, 0, el.url);
                else if (el.tag === 'thirdSalary') temp.splice(2, 0, el.url);
              });
            setGetSalaryDoc([...temp]);
          })
          .catch(err => {});
        await getIncomeSalaryDoc(lead_Id, leadAppicant_Id, 'income', 'form16')
          .then(res => {
            setForm16Result(res);

            let temp = [];
            if (res.links.length > 0)
              res.links.map(el => {
                if (
                  staticData?.isLems &&
                  tags?.includes(el?.tag) &&
                  form16File !== 'multiFile'
                )
                  setForm16File('multiFile');
                if (el.tag === 'first16') temp.splice(0, 0, el.url);
                if (el.tag === 'second16') temp.splice(1, 0, el.url);
              });

            setForm16Doc([...temp]);
          })
          .catch(err => {});
        setLetGetOver(true);
      }
    })().catch(err => {
      setLetGetOver(true);
    });
  }, [lead_Id, leadAppicant_Id]);

  // applying conditions for popUps
  const applyCondtn = () => {
    if (docUploaded || docUploadError || loading) return true;
  };

  // props rendered for PopUp
  const propsRenderer = () => {
    let props = {};
    if (docUploaded) {
      props.type = 'success';
      props.text = 'Document uploaded successfully';
      props.autoClose = true;
      return props;
    }

    if (docUploadError) {
      props.type = 'fail';
      props.text = 'Error uploading the file, please try again ';
      props.autoClose = true;
      return props;
    }

    if (loading) {
      props.type = 'loading';
      props.text = 'Uploading document. . . ';
      return props;
    }
  };
  //handling loading
  useEffect(() => {
    if (docUploadError || docUploaded) setLoading(false);
  }, [docUploaded, docUploadError]);

  //checking the upload status for indiv. files of salarySlips
  useEffect(() => {
    setDocUploaded(false);
    setDocUploadError(false);
    setShow(true);
    if (data.file[0] && data.file[0] !== '') {
      setLoading(true);
      incomeDocUpload(
        data.file[0][0],
        lead_Id,
        leadAppicant_Id,
        'salary-slip',
        'firstSalary',
        { 'Content-Type': `${data.file[0][0].type}` }
      )
        .then(res => {
          let docId = res.requestId;
          UploadFileToS3(res.url, data.file[0][0], {
            'Content-Type': `${data.file[0][0].type}`
          })
            .then(res => {
              incomeDocUploaded(lead_Id, leadAppicant_Id, docId, 'salary-slip')
                .then(res => {
                  setDocUploaded(true);
                  setSalaryMinUploaded(true);
                  setSalaryDocUploads({ ...salaryDocUploads, 0: 'uploaded' });
                })
                .catch(err => setDocUploadError(true));
            })
            .catch(err => setDocUploadError(true));
        })
        .catch(err => {
          setDocUploadError(true);
        });
    }
  }, [data.file[0]]);

  useEffect(() => {
    setDocUploaded(false);
    setDocUploadError(false);
    setShow(true);
    if (data.file[1] && data.file[1] !== '') {
      setLoading(true);
      incomeDocUpload(
        data.file[1][0],
        lead_Id,
        leadAppicant_Id,
        'salary-slip',
        'secondSalary'
      )
        .then(res => {
          let docId = res.requestId;
          UploadFileToS3(res.url, data.file[1][0])
            .then(res => {
              incomeDocUploaded(lead_Id, leadAppicant_Id, docId, 'salary-slip')
                .then(res => {
                  setDocUploaded(true);
                  setSalaryMinUploaded(true);

                  setSalaryDocUploads({ ...salaryDocUploads, 1: 'uploaded' });
                })
                .catch(err => setDocUploadError(true));
            })
            .catch(err => setDocUploadError(true));
        })
        .catch(err => setDocUploadError(true));
    }
  }, [data.file[1]]);

  useEffect(() => {
    setDocUploaded(false);
    setDocUploadError(false);
    setShow(true);
    if (data.file[2] && data.file[2] !== '') {
      setLoading(true);
      incomeDocUpload(
        data.file[2][0],
        lead_Id,
        leadAppicant_Id,
        'salary-slip',
        'thirdSalary'
      )
        .then(res => {
          let docId = res.requestId;
          UploadFileToS3(res.url, data.file[2][0])
            .then(res => {
              incomeDocUploaded(lead_Id, leadAppicant_Id, docId, 'salary-slip')
                .then(res => {
                  setDocUploaded(true);
                  setSalaryMinUploaded(true);
                  setSalaryDocUploads({ ...salaryDocUploads, 2: 'uploaded' });
                })
                .catch(err => setDocUploadError(true));
            })
            .catch(err => setDocUploadError(true));
        })
        .catch(err => setDocUploadError(true));
    }
  }, [data.file[2]]);

  useEffect(() => {
    setDocUploaded(false);
    setDocUploadError(false);
    setShow(true);
    if (data.file[3] && data.file[3] !== '') {
      setLoading(true);
      incomeDocUpload(
        data.file[3][0],
        lead_Id,
        leadAppicant_Id,
        'form16',
        'first16'
      )
        .then(res => {
          let docId = res.requestId;
          UploadFileToS3(res.url, data.file[3][0])
            .then(res => {
              incomeDocUploaded(lead_Id, leadAppicant_Id, docId, 'form16')
                .then(res => {
                  setDocUploaded(true),
                    setSalaryDocUploads({ ...salaryDocUploads, 3: 'uploaded' });
                })
                .catch(err => setDocUploadError(true));
            })
            .catch(err => setDocUploadError(true));
        })
        .catch(err => console.log(err));
    }
  }, [data.file[3]]);
  useEffect(() => {
    setDocUploaded(false);
    setDocUploadError(false);
    setShow(true);
    if (data.file[4] && data.file[4] !== '') {
      setLoading(true);
      incomeDocUpload(
        data.file[4][0],
        lead_Id,
        leadAppicant_Id,
        'form16',
        'second16'
      )
        .then(res => {
          let docId = res.requestId;
          UploadFileToS3(res.url, data.file[4][0])
            .then(res => {
              incomeDocUploaded(lead_Id, leadAppicant_Id, docId, 'form16')
                .then(res => {
                  setDocUploaded(true),
                    setSalaryDocUploads({ ...salaryDocUploads, 4: 'uploaded' });
                })
                .catch(err => setDocUploadError(true));
            })
            .catch(err => setDocUploadError(true));
        })
        .catch(err => console.log(err));
    }
  }, [data.file[4]]);

  //for F16 validation
  useEffect(() => {
    if (
      (data.file[3] && data.file[3] !== '') ||
      (data.file[4] && data.file[4] !== '')
    ) {
      setF16MinUploaded(true);
    } else setF16MinUploaded(false);
  }, [...validationF16SlipFields]);

  useEffect(() => {
    validateForm();
  }, []);

  return letGetOver ? (
    <>
      {applyCondtn() && (
        <PopUp {...propsRenderer()} setShow={setShow} show={show} />
      )}

      <div className="outer_comp w-full font-roboto px-8 mt-8 ">
        <p className="font-normal font-roboto text-black-100 text-base">
          Upload your latest 3 Months salary slip or Salary Certificate
        </p>
        <div>
          {/* <GlobalMonthRangePicker
            maxMonth={6}
            multiValue={[...multiValue]}
            setMultiValue={setMultiValue}
            rangeValue={{ ...rangeValue }}
            setRangeValue={setRangeValue}
            validRange={validRange} //{min: 2013}
          /> */}
          <div className="mt-5">
            <GlobalMonthRangePicker
              autoRange={3} //in months
              rangeValue={{ ...rangeValue }}
              setRangeValue={setRangeValue}
              validRange={{ ...validRange }} //{min: 2013}//[2013, 2015, 2016]//5// {max: 2015}
            />
          </div>
        </div>
        <div className="flex flex-row flex-wrap justify-start  mt-5">
          <div className="m-2 mx-auto">
            {getSalaryDoc[0] && !edit0 ? (
              <div className="ml-2 mt-4">
                <ShowGetImage img={getSalaryDoc[0]} setEdit={setEdit0} />
              </div>
            ) : (
              <>
                <p className="font-roboto font-normal text-grey-50 text-left ml-2 md:ml-0 md:text-center mb-2 md:mb-0">
                  {moment((rangeValue.from.month + 2).toString(), 'M').format(
                    'MMM'
                  ) +
                    ',' +
                    rangeValue.from.year}
                </p>
                <GlobalUploadComp
                  data={data}
                  imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                  errors={errors}
                  touched={touched}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  setFieldError={setFieldError}
                  showFullImage={showFullImage} // boolean , to change mobile upload image view
                  initialImg={initialImg} // initial image
                  subInst="Click here to upload"
                  subtext="CHOOSE FRONT VIEW"
                />
              </>
            )}
          </div>
          <div className="m-2 mx-auto">
            {getSalaryDoc[1] && !edit1 ? (
              <div className="ml-2 mt-4">
                <ShowGetImage img={getSalaryDoc[1]} setEdit={setEdit1} />
              </div>
            ) : (
              <>
                <p className="font-roboto font-normal text-grey-50 text-left ml-2 md:ml-0 md:text-center mb-2 md:mb-0">
                  {moment((rangeValue.from.month + 1).toString(), 'M').format(
                    'MMM'
                  ) +
                    ',' +
                    rangeValue.from.year}
                </p>
                <GlobalUploadComp
                  data={data}
                  imgIndex={1} //0,1,2,3 depending upon the no of file sequence
                  errors={errors}
                  touched={touched}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  setFieldError={setFieldError}
                  showFullImage={showFullImage} // boolean , to change mobile upload image view
                  initialImg={initialImg} // initial image
                  subInst="Click here to upload"
                  subtext="CHOOSE FRONT VIEW"
                />
              </>
            )}
          </div>
          <div className="m-2 mx-auto">
            {getSalaryDoc[2] && !edit2 ? (
              <div className="ml-2 mt-4">
                <ShowGetImage img={getSalaryDoc[2]} setEdit={setEdit2} />
              </div>
            ) : (
              <>
                <p className="font-roboto font-normal text-grey-50 text-left ml-2 md:ml-0 md:text-center mb-2 md:mb-0">
                  {moment(rangeValue.from.month.toString(), 'M').format('MMM') +
                    ',' +
                    rangeValue.from.year}
                </p>
                <GlobalUploadComp
                  data={data}
                  imgIndex={2} //0,1,2,3 depending upon the no of file sequence
                  errors={errors}
                  touched={touched}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  setFieldError={setFieldError}
                  showFullImage={showFullImage} // boolean , to change mobile upload image view
                  initialImg={initialImg} // initial image
                  subInst="Click here to upload"
                  subtext="CHOOSE FRONT VIEW"
                />
              </>
            )}
          </div>
        </div>

        <p className="font-normal font-roboto text-black-200 text-sm mt-10">
          Upload your last 2 year Form 16
        </p>
        {staticData?.isLems && (
          <div className="w-full flex-wrap flex gap-5 mt-3">
            <div className="flex">
              <RadioButton
                checked={form16File == 'singleFile'}
                onChange={() => setForm16File('singleFile')}
              />
              <p className="text-grey-2234 font-roboto text-sm  ml-1">
                Single File
              </p>
            </div>
            <div className="flex">
              <RadioButton
                checked={form16File == 'multiFile'}
                onChange={() => setForm16File('multiFile')}
              />
              <p className="text-grey-2234 font-roboto text-sm  ml-1">
                Multiple File
              </p>
            </div>
          </div>
        )}
        {form16File == 'multiFile' && staticData?.isLems && (
          <Form16MultiParts
            getForm16Doc={getForm16Doc}
            form16Result={form16Result}
            setF16MinUploaded={setF16MinUploaded}
            data={data}
            errors={errors}
            touched={touched}
            handleChange={handleChange}
            handleBlur={handleBlur}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            setFieldError={setFieldError}
            validateForm={validateForm}
          />
        )}
        {form16File == 'singleFile' && (
          <div className="flex flex-row flex-wrap justify-start  mt-5">
            <div className="m-2 mx-auto">
              {getForm16Doc[0] && !edit3 ? (
                <div className="ml-2 mt-4">
                  <ShowGetImage img={getForm16Doc[0]} setEdit={setEdit3} />
                </div>
              ) : (
                <>
                  <p className="font-roboto font-normal text-grey-50 text-left ml-5 md:text-center md:ml-0 mb-2 md:mb-0 ">
                    {moment()
                      .subtract(1, 'years')
                      .format('YYYY')}
                  </p>

                  <GlobalUploadComp
                    data={data}
                    imgIndex={3} //0,1,2,3 depending upon the no of file sequence
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    setFieldError={setFieldError}
                    showFullImage={showFullImage} // boolean , to change mobile upload image view
                    initialImg={initialImg} // initial image
                    subInst="Click here to upload"
                    subtext="CHOOSE FRONT VIEW"
                  />
                </>
              )}
            </div>
            <div className="m-2 mx-auto">
              {getForm16Doc[1] && !edit4 ? (
                <div className="ml-2 mt-4">
                  <ShowGetImage img={getForm16Doc[1]} setEdit={setEdit4} />
                </div>
              ) : (
                <>
                  <p className="font-roboto font-normal text-grey-50 text-left ml-5 md:text-center md:ml-0 mb-2 md:mb-0 ">
                    {moment()
                      .subtract(2, 'years')
                      .format('YYYY')}
                  </p>
                  <GlobalUploadComp
                    data={data}
                    imgIndex={4} //0,1,2,3 depending upon the no of file sequence
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    setFieldError={setFieldError}
                    showFullImage={showFullImage} // boolean , to change mobile upload image view
                    initialImg={initialImg} // initial image
                    subInst="Click here to upload"
                    subtext="CHOOSE FRONT VIEW"
                  />
                </>
              )}
            </div>
          </div>
        )}
        <div className="mt-16">
          <button
            disabled={
              (!salaryMinUploaded || !F16MinUploaded) &&
              ((!getForm16Doc.length > 0 && form16File !== 'multiFile') ||
                !getSalaryDoc.length > 0)
            }
            type="submit"
            className={' submitButton  w-56 h-12 font-medium  font-roboto '}
          >
            Next
          </button>
        </div>
      </div>
    </>
  ) : (
    <div className="min-h-screen h-screen relative">
      <div className="absolute top-3/10 inset-x-1/2">
        <CircularLoading />
      </div>
    </div>
  );
};

export default Form16;
